export default __webpack_public_path__ + "static/blob1-f0ab75d191adef557b39baddd02c1fda.svg";